module.exports = __webpack_public_path__ + "65ffba26aed7ce46ca8392ecfba59bce.svg";